// extracted by mini-css-extract-plugin
export default {"container":"Alert_container__zXu69","containerBlack":"Alert_containerBlack__pkglk","element":"Alert_element__Nrpd4","buttonSend":"Alert_buttonSend__hUqib"};